import StepTitle from '../StepTitle/StepTitle';

export default function Submitted() {
  return (
    <div className='fixed-layout'>
      <div className='fixed-layout__main'>
        <div className='narrow-container'>
          <StepTitle
            heading='Congratulations'
            text='You are one step closer to having your vechicle secured. We will be in touch very soon.'
          />
        </div>
      </div>
    </div>
  );
}
